import PropTypes from 'prop-types';

const internals = {};

internals.colors = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '0ff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '00f',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  blushedcoral: 'f08080',
  burlywood: 'deb887',
  burntsienna: 'ea7e5d',
  cadetblue: '5f9ea0',
  champagne: 'f7e7ce',
  chartreuse: 'aae46b',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '0ff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'f0f',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lilacbloom: '86608e',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'ff0090',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peach: 'ffdab9',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '663399',
  radiantred: '9d383e',
  red: 'f00',
  romanticpink: 'ffb6c1',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seaglass: '90cb8d',
  seafoam: '71eeb8',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  softsand: 'c3b995',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  tangerine: 'f28500',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  touchofgold: 'bf9d3e',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32',
  chevron_bw: '//cdn.sandals.com/sandals/v12/images/wedding-styler/thumbnail-patterns/chevron_bw.jpg',
  stripes_bw: '//cdn.sandals.com/sandals/v12/images/wedding-styler/thumbnail-patterns/stripes_bw.jpg'
};

export default class CustomColorPicker extends React.Component {
  static propTypes = {
    itemColors: PropTypes.array,
    currentItemColor: PropTypes.string,
    fetchItemByAttributeId: PropTypes.func,
    layoutSize: PropTypes.string,
    colorLabelSize: PropTypes.string,
    ddlTextWrapperSize: PropTypes.string,
    editItemCallback: PropTypes.func
  };

  static defaultProps = {
    layoutSize: 'xs-12',
    colorLabelSize: 'xs-12',
    ddlTextWrapperSize: '',
    fetchItemByAttributeId: () => {},
    editItemCallback: () => {}
  };

  constructor(props) {
    super(props);

    const colorName = this.props.currentItemColor.toLowerCase().replace(/\s/g, '');

    this.state = {
      selectedColor: null,
      isActiveDdl: false,
      colorName
    };
  }

  componentDidMount() {
    $(document).on('click', (e) => {
      if ($(e.target).closest('.custom-colorpicker').length === 0 && this.state.isActiveDdl) {
        this.setState({ isActiveDdl: false });
      }
    });
  }

  _componentFocusHandler = (e) => {
    e.currentTarget.tabIndex = 1;
  }

  _onClickDropDownHandler = () => {
    this.setState({
      isActiveDdl: !this.state.isActiveDdl
    });
  }

  _onClickDropDownItemHandler = (e) => {
    const ddlItem = $(e.currentTarget);
    const colorName = ddlItem.data('color-name');
    const selectedColor = parseInt(e.currentTarget.id, 10);


    this.setState({
      isActiveDdl: !this.state.isActiveDdl,
      selectedColor,
      colorName
    }, () => {
      this.props.editItemCallback(colorName);
      this.props.fetchItemByAttributeId(selectedColor);
    });

  }

  _renderDropDownItems = (colorObj) => {
    const colorName = colorObj.color.toLowerCase();
    const hexColor = internals.colors[colorName.replace(/\s/g, '')] || 'dedede';
    const chevron = colorName.includes('chevron');
    const stripes = colorName.includes('stripes');

    let bgColor = '';

    if(chevron || stripes) {
      bgColor = { background: `url(${hexColor})` };
    } else {
      bgColor = { background: `#${hexColor}` };
    }

    return (
      <div key={hexColor} id={colorObj.id} data-color-name={colorObj.color} className="color-ddl-item row" onClick={ this._onClickDropDownItemHandler }>
        <div style={bgColor} className="color-box xs-1 lg-2"/>
        <div className="xs-8 color-name">{_.capPhrase(colorObj.color.toLowerCase())}</div>
      </div>
    );
  }

  render() {
    const hexColor = internals.colors[this.state.colorName.toLowerCase().replace(/\s/g, '')] || 'dedede';
    const colorName = this.state.colorName.toLowerCase().replace(/\s/g, '');
    const chevron = colorName.includes('chevron');
    const stripes = colorName.includes('stripes');
    let bgColor = '';

    if(chevron || stripes) {
      bgColor = { background: `url(${hexColor})` };
    } else {
      bgColor = { background: `#${hexColor}` };
    }

    return (
      <div className={`${this.props.layoutSize} lg-4 custom-colorpicker pr`}>
        <label htmlFor="itemColor" className={`item-details-label ${this.props.colorLabelSize}`}>Color:</label>
        <div className={`control-wrapper custom-ddl color ${this.props.ddlTextWrapperSize}`} ref={ (input) => { this.colorPicker = input; } } tabIndex="0">
          <div className="ddl-text" onClick={ this._onClickDropDownHandler }>
            <div style={bgColor} className="color-box"/>
            <span className="color-name">{_.capPhrase(this.state.colorName.toLowerCase())}</span>
          </div>
          <div className={`colors-ddl bg-white pa ${this.state.isActiveDdl}`}>
            {
              this.props.itemColors && this.props.itemColors.map((colorObj) => this._renderDropDownItems(colorObj))
            }
          </div>
          <input type="hidden"/>
        </div>
      </div>
    );
  }
}
